<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break="960"
    app
    width="250"
    v-bind="$attrs"
  >
    <user-information />
    <v-divider class="mb-2" />

    <div v-if="isAdmin" class="px-4">
      <div
        v-if="customerName"
        class="white--text text-center text-subtitle-2 pa-2 pb-3"
      >
        {{ customerName }}
      </div>
      <v-menu v-else offset-y max-height="500">
        <template v-slot:activator="{ on }">
          <v-btn text class="text-capitalize text-subtitle-2" v-on="on" block>
            {{ orgName ? orgName : 'Select Organizations' }}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in organizations"
            :key="index"
            @click="changeOrg(item)"
          >
            <v-list-item-avatar
              color="grey"
              min-width="28"
              height="28"
              width="28"
            >
              <v-img :src="item.file_url" v-if="item.file_url" />
            </v-list-item-avatar>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-divider v-if="isAdmin" class="mb-2" />
    <div class="px-4">
      <div
        v-if="sports.length < 2"
        class="text-center white--text text-capitalize text-subtitle-2 pa-2 pb-3"
      >
        {{ sportName }}
      </div>
      <v-menu v-else offset-y max-height="500">
        <template v-slot:activator="{ on }">
          <v-btn
            text
            dark
            block
            class="text-capitalize text-subtitle-2"
            v-on="on"
          >
            {{ sportName ? sportName : 'Select a sport' }}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(obj, index) in sports"
            :key="index"
            @click="changeSport(obj)"
          >
            <v-list-item-title class="text-capitalize">
              {{ obj.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-divider class="mb-2" />
    <v-list expand nav v-if="computedItems.length > 0">
      <div />
      <template v-for="(item, i) in computedItems">
        <template v-if="setMenu(claims, item)">
          <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          />
          <base-item v-else :key="`item-${i}`" :item="item" />
        </template>
      </template>
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { db, organizationsCollection } from '@/utils/firebase';
import UserInformation from './UserInformation';
import { remoteConfig } from '@/utils/firebase';

export default {
  name: 'DashboardCoreDrawer',
  components: {
    UserInformation,
  },
  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    organizations: [],
    computedItems: [],
    sportsItems: [],
    sportsValue: [],
    sportNames: [],
    sportList: ['tackle_football', 'flag_football'],
  }),
  computed: {
    ...mapState({
      claims: (state) => state.user.claims,
      barColor: (state) => state.barColor,
      barImage: (state) => state.barImage,
      orgId: (state) => state.user.orgId,
      orgName: (state) => state.user.orgName,
      isLogged: (state) => state.user.isLogged,
      isAdmin: (state) => state.user.isAdmin,
      customerId: (state) => state.user.customerId,
      customerName: (state) => state.user.customerName,
      customerEndDate: (state) => state.user.customerEndDate,
      customerPokenCredit: (state) => state.user.customerPokenCredit,
      sportId: (state) => state.user.sportId,
    }),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val);
      },
    },
    sports() {
      return this.sportsItems.filter(function (obj) {
        return this.sportsValue.includes(obj.id);
      }, this);
    },
    sportName() {
      const item = this.sportsItems.filter(function (obj) {
        return this.sportId === obj.id;
      }, this);
      return item.length > 0 ? item[0].title : '';
    },
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.$emit('update:expandOnHover', !val);
    },
    orgId: function (val) {
      this.getOrgById();
      this.fetchData(val);
    },
    customerId: function (val) {
      this.fetchData(val);
    },
  },
  mounted() {
    this.fetchData();
    this.getSports();
    this.getOrgList();
    this.getOrgById();
  },
  methods: {
    checkConf(id) {
      const remoteConf = remoteConfig.getValue('old_features');
      const remoteVal = remoteConf._value || [];
      return remoteVal.includes(id);
    },
    getSports() {
      let sportsItems = [];
      db.collection('sports')
        .orderBy('title', 'asc')
        .get()
        .then((doc) => {
          if (doc.docs.length > 0) {
            doc.forEach((item) => {
              let post = item.data();
              post.id = item.id;
              sportsItems.push(post);
            });
          }
        });
      this.sportsItems = sportsItems;
    },
    getOrgById() {
      if (this.orgId) {
        organizationsCollection
          .doc(this.orgId)
          .get()
          .then((doc) => {
            if (!doc || !doc.exists) {
              return;
            }
            this.sportsValue = doc.data().sports || [];
          });
      }
    },
    changeOrg(item) {
      if (!item.sports || item.sports.length === 0) {
        this.$store.dispatch('notification/add', {
          message: `Can you select a sport for ${item.name}?`,
          type: 'error',
        });
        return;
      }
      this.$store.dispatch('user/changeOrg', {
        orgId: item.id,
        orgName: item.name,
        projectId: item.project_id,
        isTest: item.is_test,
      });
      this.$store.dispatch('user/changeSport', {
        id: item.sports[0],
      });
      this.$store.dispatch('user/changeCustomer', {
        id: '',
        name: '',
        date: '',
        credit: '',
      });
      this.verifyRoute(`/dashboard`);
    },
    changeSport(item) {
      if (item) {
        this.$store.dispatch('user/changeSport', {
          id: item.id,
        });
        this.fetchData();
        const isTactic = this.$route.name.toLowerCase().includes('tactic');
        if (isTactic && this.sportList.indexOf(this.sportId) >= 0) {
          this.$router.push('/dashboard');
        }
      }
    },
    getOrgList() {
      organizationsCollection
        .orderBy('name', 'asc')
        .onSnapshot((querySnapshot) => {
          if (querySnapshot.docs.length) {
            let postsArray = [];
            querySnapshot.forEach((doc) => {
              let post = doc.data();
              post.id = doc.id;
              if (!this.checkConf(doc.id)) {
                postsArray.push(post);
              }
            });
            this.organizations = postsArray;
          }
        });
    },
    setMenu(claims, menu) {
      return menu.roles.includes(claims.role_code);
    },
    fetchData() {
      let items = [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/dashboard',
          roles: ['AAD', 'OAD'],
        },
        {
          icon: 'mdi-domain',
          title: 'partners',
          to: '/organizations/grid',
          roles: ['AAD'],
        },
        {
          icon: 'mdi-alarm',
          title: 'drills',
          to: '/drills',
          roles: ['AAD', 'OAD', 'OCE'],
        },
        {
          icon: 'mdi-camera-metering-center',
          title: 'plans',
          to: '/plans',
          roles: ['AAD', 'OAD', 'OCE'],
        },
        {
          icon: 'mdi-alarm',
          title: 'drills',
          to: '/list/d',
          roles: ['VIEW'],
        },
        {
          icon: 'mdi-camera-metering-center',
          title: 'plans',
          to: '/list/p',
          roles: ['VIEW'],
        },
        {
          icon: 'mdi-star',
          title: 'skills',
          to: '/skills',
          roles: ['AAD', 'OAD', 'OCE'],
        },
        {
          icon: 'mdi-dumbbell',
          title: 'exercises',
          to: '/exercises',
          roles: ['AAD', 'OAD', 'OCE'],
        },
        {
          icon: 'mdi-file-document',
          title: 'docs',
          to: '/docs',
          roles: ['AAD', 'OAD', 'OCE'],
        },
      ];

      let array = [
        {
          icon: 'mdi-account-multiple',
          title: 'users',
          to: '/users',
          roles: ['AAD', 'OAD'],
        },
        {
          icon: 'mdi-cog-outline',
          title: 'settings',
          to: '/settings',
          roles: ['AAD', 'OAD'],
        },
      ];

      if (this.sportId) {
        if (this.sportList.indexOf(this.sportId) == -1) {
          const tacticMenu = {
            icon: 'mdi-strategy',
            title: 'tactics',
            to: '/tactics',
            roles: ['AAD', 'OAD', 'OCE'],
          };
          items.splice(7, 0, tacticMenu);
        }

        if (this.sportList.includes(this.sportId)) {
          const playMenu = {
            icon: 'mdi-book',
            title: 'plays',
            to: '/plays',
            roles: ['AAD', 'OAD', 'OCE'],
          };
          items.push(playMenu);
        }
      }

      if (this.customerId) {
        array = [
          {
            icon: 'mdi-account-multiple',
            title: 'users',
            to: `/users/${this.orgId}/customers/${this.customerId}`,
            roles: ['AAD', 'OAD'],
          },
        ];
        if (this.customerEndDate && this.customerPokenCredit) {
          const nowDate = moment().format('YYYY-MM-DD');
          const endDate = moment(this.customerEndDate).format('YYYY-MM-DD');

          if (endDate >= nowDate && +this.customerPokenCredit > 0) {
            let obj = {
              icon: 'mdi-shield-account',
              title: 'premium_credits',
              to: '/premium_credits',
              roles: ['AAD', 'OAD'],
            };
            array.push(obj);
          }
        }
      }
      items = [...items, ...array];
      this.computedItems = items;
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
    verifyRoute(param) {
      const from = this.$route.path;

      if (from === param) return;

      return this.$router.push(param);
    },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
